import React from 'react'
import { Route, Switch, Redirect } from 'react-router'
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

import Header from "../components/CreativeHeader/CreativeHeader";
import SearchBar from "../components/Search/SearchBar";
import Campaign from "../components/Campaign/Campaign";
import Brand from "../components/Brand/Brand";
import Unit from "../components/Unit/Unit";
import Search from "../components/Search/Search";
import DashBoard from "../components/Dashboard/Dashboard";
import Functionality from "../components/Functionality/Functionality";
import Vertical from "../components/Vertical/Vertical";
import EmptyCampaigns from "../components/Empty/EmptyCampaigns";
import EmptyBrands from "../components/Empty/EmptyBrands";
import JiraUnits from "../components/Empty/JiraUnits";
import MyCreatives from "../components/Submenu/MyCreatives"
import Report from "../components/Report/Report";
import Sellers from "../components/Sellers/Sellers";
import Users from "../components/User/Users";
import NoMatch from "../components/Page/NoMatch";
import UnAuthorized from "../components/Page/UnAuthorized";
import Loading from '../components/Shared/Loading';
import Headline from "../components/Shared/headline";
import Login from "../components/Page/Login";
// import Admin from "../components/Admin/Admin";
import $ from 'jquery';

const checkPermissions = (userPermissions, allowedPermissions) => {
    if (allowedPermissions.length === 0) {
        return true;
    }
    return userPermissions.some(permission =>
        allowedPermissions.includes(permission)
    );
};

const ProtectedRoute = ({ component: Component, user: user, allowedPermissions:allowedPermissions,...rest }) => (
    <Route {...rest} render={(props) => {
        if (user.loading) {
            return <Loading />;
        }
        return (
            user.isAuthenticated === true && checkPermissions(user.roles,allowedPermissions)
                ? <Component {...props} />
                : <Redirect to={{
                    pathname: '/unauthorized',
                    state: { from: props.location }
                }} />
        )
    }} />
);
class routes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            setSmall: false,
            small: false,
        };
    }
    componentDidMount() {
        if (typeof window !== "undefined") {
            let that = this;
            let headerContainer = $('.header-container');
            let html = $("html, body");
            let body =  $("body");
            $(window).scroll(function () {
                let displayHeader =  $('.search-header');
                if ( $(this).scrollTop() > 222 && !headerContainer.hasClass('sticky-header') ) {
                    headerContainer.addClass('sticky-header');
                    $('.search-table thead').addClass('sticky');
                    displayHeader.addClass('sticky-display-header');
                    html.scrollTop(html.scrollTop() - 222);
                    body.css('padding-top', '198px');
                    $(".sticky-header").css({'transform': 'translateY(-104px)'});
                    $(".sticky").css({'transform': 'translateY(-104px)'});
                    $(".sticky-display-header").css({'transform': 'translateY(-104px)'});
                    setTimeout(function() {
                        $(".sticky-header").css({
                            transform: 'translateY(0px)',
                            transition: 'all 250ms ease-out 0s'
                        });
                        $(".sticky-display-header").css({
                            transform: 'translateY(0)',
                            top: '112px',
                            transition: 'all 250ms ease-out 0s',
                            background: '#fff',
                            zIndex: 81,
                        });
                        $(".sticky").css({
                            transform: 'translateY(0)',
                            top: '189px',
                            transition: 'all 250ms ease-out 0s',
                            zIndex: 81
                        });

                    },0)
                    that.setState({small: true});
                } else if($(this).scrollTop() == 0){
                    let stickyHeader =  $(".sticky-header");
                    let sticky = $('.sticky');
                    let tableDisplayHeader =   $('.search-table thead');
                    stickyHeader.removeClass('');
                    sticky.removeClass('');
                    $('.sticky-display-header').removeClass('');
                    stickyHeader.css({transform: ""});
                    tableDisplayHeader.removeClass('sticky')
                    displayHeader.removeClass('sticky-display-header')
                    headerContainer.removeClass('sticky-header');
                    headerContainer.css({transition:''})
                    tableDisplayHeader.css({
                        transition:'',
                        transform:'',
                        background: '',
                        zIndex: 0,
                        top: 0
                    })
                    displayHeader.css({
                        transition:'',
                        transform:'',
                        background: '',
                        top: 0,
                        zIndex: 1
                    })
                    body.css({
                        'padding-top': 0
                    })
                    that.setState({small: false});
                }
            });
        }
    }


    render() {
        return (
            <div className="main-wrapper">
            <div className={`outside-header ${this.state.small ? "outside-header-none" : ""}` }>
                <div className={`header-container ${this.state.small ? "sticky-header" : ""}`}>
                    <Header user={this.props.user} hide={this.state.small} location={this.props.location}/>
                    {this.props.location.pathname === "/" ? <Headline hide={this.state.small} /> : ""}
                    <SearchBar location={this.props.location} sticky={this.state.small}/>
                </div>
            </div>
            <div className="wrapper">
                <div className="inner-wrapper">
                    <Switch>
                        <Route path="/campaign/:cid" user={this.props.user} component={Campaign}/>
                        <Route path="/brand/:bid" component={Brand} />
                        <Route path="/live/:id" render={(props) => <Unit {...props} type="live" />} />
                        <Route path="/mock/:id" render={(props) => <Unit {...props} type="mock" />} />
                        <Route path="/search" component={Search} />
                        <Route user={this.props.user} path="/latest-units" component={DashBoard}/>
                        {/*<ProtectedRoute user={this.props.user} allowedPermissions={['admin']} path="/manage/admin" exact component={Admin} />*/}
                        <ProtectedRoute user={this.props.user} allowedPermissions={['admin', 'analytics', 'editor']} path="/export" component={Report}/>
                        <ProtectedRoute user={this.props.user} allowedPermissions={['admin']} path="/manage/functionality" exact component={Functionality} />
                        <ProtectedRoute user={this.props.user} allowedPermissions={['admin']} path="/manage/verticals" exact component={Vertical} />
                        <ProtectedRoute user={this.props.user} allowedPermissions={['admin', 'editor']} path="/manage/brands" exact component={EmptyBrands} />
                        <ProtectedRoute user={this.props.user} allowedPermissions={['admin', 'editor']} path="/manage/campaigns" exact component={EmptyCampaigns} />
                        <ProtectedRoute user={this.props.user} allowedPermissions={['admin', 'editor']} path="/manage/jira_units" exact component={JiraUnits} />
                        <ProtectedRoute user={this.props.user} allowedPermissions={['admin', 'editor']} path="/manage/my_creatives" exact component={MyCreatives} />
                        <ProtectedRoute user={this.props.user} allowedPermissions={['admin']} path="/manage/sellers" exact component={Sellers} />
                        <ProtectedRoute user={this.props.user} allowedPermissions={['admin']} path="/manage/users" exact component={Users} />
                        <Route path="/login" exact component={Login} />
                        <Route path="/unauthorized" component={UnAuthorized} />
                        <Route path="/" exact component={DashBoard} />
                        <Route component={NoMatch} />
                    </Switch>
                </div>
            </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    currentPage: state.latestUnits.currentPage,
    user: state.user
});

export default withRouter(connect(mapStateToProps)(routes));
